import * as React from 'react';
import { Grid, Button, Dialog, DialogContentText, DialogActions, DialogContent, Select, MenuItem, InputLabel, FormControl, TextField, DialogTitle, InputAdornment } from '@material-ui/core';

interface Props {
    isOpen: boolean;
    title?: string;
    handleClose: () => void;
    submit: (formData: object) => void;
    content: string;
    textBox?: {
        label?: string;
        rows?: number;
        placeholder?: string;
    };
    select?: {
        label?: string;
        items: any[];
    }
    input?: {
        label?: string;
        variant?: "outlined" | "standard" | "filled" | undefined;
    };
    confirmTxt?: string;
    cancelTxt?: string;
};

const UpdateInfoDialog: React.FC<Props> = (prop: Props) => {
    const [formData, setFormData] = React.useState({});

    const handleChangeInput = (target: any) => {
        setFormData({...formData, [target.name]: target.value});
    }

    React.useEffect(() => {
        if (prop.select?.items && !formData.hasOwnProperty('select')) {
            setFormData({...formData, select: prop.select.items[0]});
        }
    });

    return (
        <>
            <Dialog open={prop.isOpen} 
                onClose={prop.handleClose}>
                    <DialogTitle>{prop.title || 'Confirm'}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {prop.content}
                    </DialogContentText>
                    <Grid container direction="row" justify="flex-start" alignItems="flex-end" spacing={4}>
                        <Grid item>
                            {prop.textBox && 
                                <FormControl>
                                    <TextField variant="outlined" 
                                        name="textField"
                                        multiline
                                        onChange={(e) => handleChangeInput(e.target)}
                                        label={prop.textBox.label || ''}
                                        rows={prop.textBox.rows || 1}
                                        placeholder={prop.textBox.placeholder || ''} />
                                </FormControl>}
                        </Grid>
                            {prop.select && 
                                <Grid item>
                                    <FormControl>
                                        <InputLabel htmlFor="uncontrolled-native">{prop.select.label || ''}</InputLabel>
                                        <Select defaultValue={prop.select.items[0]}
                                            name="select"
                                            onChange={(e) => handleChangeInput(e.target)}>
                                            {prop.select.items.map((item, idx) => 
                                                <MenuItem key={idx} value={item}>{item}</MenuItem> )}
                                        </Select>
                                    </FormControl>
                                </Grid>}
                            {prop.input && 
                                <Grid item>
                                    <FormControl>
                                        <TextField variant={prop.input.variant || "standard"}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">$</InputAdornment>
                                                )
                                            }}
                                            name="input"
                                            label={prop.input.label} 
                                            onChange={(e) => handleChangeInput(e.target)}
                                            />
                                    </FormControl>
                                </Grid>}
                    </Grid>
                    <DialogActions>
                        <Button onClick={prop.handleClose} color="primary">
                            {prop.cancelTxt || 'Cancel'}
                        </Button>
                        <Button color="primary" onClick={() => {
                                prop.submit(formData);
                            }}>
                            {prop.confirmTxt || 'Ok'}
                        </Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default UpdateInfoDialog;